import {
  getRewardsAccount,
  useGetAccountsRewardsQuery,
} from "@hsbc/core-rewards";

export const useMaxOverpay = (): number | null => {
  const { pointsToCashRate } = useGetAccountsRewardsQuery(undefined, {
    selectFromResult: ({ data }) => ({
      pointsToCashRate: getRewardsAccount(data).conversionMultiplier,
    }),
  });

  return pointsToCashRate ? pointsToCashRate - 0.01 : null;
};
